import React, { useState, useEffect } from 'react';
import { Col, Row, Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import IconButton from 'components/common/IconButton';
import ActionButton from 'components/common/ActionButton';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { numberFormatter } from 'helpers/utils';
import { removeFence } from 'reducers/livingCarbonGrantReducer';

const BulAction = ({ onDrawPlantingSite }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Row className="flex-between-center mb-3">
        <Col sm="auto" className="ms-auto text-end ps-0">
          <IconButton
            variant="falcon-default"
            size="sm"
            icon="plus"
            transform="shrink-3"
            className="me-2"
            onClick={() => handleShow()}
          >
            <span className="d-none d-sm-inline-block ms-1">New</span>
          </IconButton>
        </Col>
      </Row>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="side-name-modal"
        backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title id="side-name-modal">
            Select type of development
          </Modal.Title>
          <FalconCloseButton
            onClick={() => {
              setShow(false);
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <IconButton
            className="my-3"
            icon="plus"
            onClick={() => {
              setShow(false);
              onDrawPlantingSite(3);
            }}
          >
            New Fence
          </IconButton>
          <br />
          <IconButton
            className="my-3"
            icon="plus"
            onClick={() => {
              setShow(false);
              onDrawPlantingSite(4);
            }}
          >
            Existing Fence
          </IconButton>
        </Modal.Body>
      </Modal>
    </>
  );
};

BulAction.propTypes = {
  onDrawPlantingSite: PropTypes.func
};

const FenceTable = ({ onDrawPlantingSite }) => {
  const { fence } = useSelector(state => state.livingCarbonGrant);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  // const handleLandParcelCenter = value => {
  //   dispatch(setPlantingSiteFocus(value.original.id));
  // };

  const columns = [
    {
      accessorKey: 'id',
      header: 'ID',
      meta: {
        headerProps: { className: 'text-900' }
      }
    },
    {
      accessorKey: 'type',
      header: 'Type',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { type } = original;
        if (type === 0) {
          return 'New';
        } else {
          return 'Existing';
        }
      }
    },
    {
      accessorKey: 'distance',
      header: 'Distance',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { dist } = original;
        return numberFormatter(dist, 2) + 'M'; // 'K' already appended, append another M to make it say 'KM'
      }
    },
    {
      accessorKey: 'actions',
      header: 'Actions',
      cell: ({ row: { original } }) => {
        return (
          <>
            <ActionButton
              icon="arrows-to-dot"
              title="Center"
              variant="action"
              className="p-0 me-2"
              onClick={() => console.log('center')}
            />
            <ActionButton
              icon="edit"
              title="Edit"
              variant="action"
              className="p-0 me-2"
              onClick={() => console.log('Edit row ', original)}
            >
              Edit
            </ActionButton>
            <ActionButton
              icon="trash-alt"
              title="Delete"
              variant="action"
              className="p-0"
              onClick={() => dispatch(removeFence(original.id))}
            >
              Delete
            </ActionButton>
          </>
        );
      }
    }
  ];

  useEffect(() => {
    setData(fence);
  }, [fence]);

  const table = useAdvanceTable({
    data,
    columns,
    sortable: true,
    selection: false,
    pagination: true,
    perPage: 5,
    selectionColumnWidth: 30
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <BulAction onDrawPlantingSite={onDrawPlantingSite} />
        <AdvanceTable
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            striped: true,
            className: 'fs-10 mb-0 overflow-hidden'
          }}
        />
      </AdvanceTableProvider>
    </>
  );
};

FenceTable.propTypes = {
  onDrawPlantingSite: PropTypes.func
};

export default FenceTable;
